import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { EFCategory } from '../../category/efCategory.model';
import { BillerList } from '../billerlist.model';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { EfcategoryService } from '../../category/efcategory.service';
import { Router } from '@angular/router';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { TranslateService } from '@ngx-translate/core';
import { Globle } from 'src/assets/globle';
import { BillerlistService } from '../billerlist.service';

@Component({
  selector: 'app-billerslist',
  templateUrl: './billerslist.component.html',
  styleUrls: ['./billerslist.component.css']
})
export class BillerslistComponent implements OnInit {

  //#region variables
  Categories: EFCategory[] = [];
  subCategories: BillerList[] = [];
  displayedColumns: string[] = ['id', 'arabicName', 'englishName', "edit"];
  dataSource!: MatTableDataSource<BillerList>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('catgSearch') catgSearch: any
  spinnerOverlay = false

  subCategory: BillerList = {} as BillerList;
  subCatgstatus: { id: number, name: string }[] = [];
  selectedStatus: number = 1;
  selectedCategory: any
  filteredOptions!: Observable<EFCategory[]>;
  searchCategory = new FormControl();
  language!: number;
  directCharge = false;
  imagPath: any;
  pageSize = 100;
  //#endregion

  constructor(private service: BillerlistService,
    private categoryService: EfcategoryService,
    private router: Router,
    private localStorage: LocalStorageService,
    private translate: TranslateService,
    private globle: Globle,
    private storage: SessionStorageService) { }

  ngOnInit() {
    this.subCatgstatus = [{ id: 1, name: this.translate.instant("active") }, { id: 0, name: this.translate.instant("notActive") }];
    this.selectedStatus = 1;
    this.language = this.localStorage.retrieve("lang");
    this.imagPath = this.globle.imgPath;
    this.pageSize = this.globle.pageSize;
    this.getCategory();
    this.searchCategory.markAsTouched();
    let category = this.storage.retrieve("categorySearch");
    if (category != null && category != undefined) {
      this.searchCategory.setValue(category);
      this.selectCatChange(category);
    }
  }

  getCategory() {
    this.spinnerOverlay = true;
    this.categoryService.getAll(this.selectedStatus).subscribe(data => {
      this.Categories = data
      this.autoCompleatFilter();
      this.spinnerOverlay = false;
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
      })
  }

  autoCompleatFilter() {
    this.filteredOptions = this.searchCategory.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.Categories.slice())
      );
  }

  private _filter(name: string): EFCategory[] {
    const filterValue = name.toLowerCase();

    return this.Categories.filter(option => option.aDesc.toLowerCase().indexOf(filterValue) === 0);
  }

  displayFn(category: EFCategory): string {
    return category && category.aDesc ? category.aDesc : '';
  }

  getSubCategory() {
    this.spinnerOverlay = true;
    this.service.getAll(this.selectedCategory, this.selectedStatus).subscribe(data => {
      this.subCategories = data.sort((n1, n2) => n2.id - n1.id);
      this.dataSource = new MatTableDataSource(this.subCategories);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  edit(id: number) {
    this.router.navigate(['./master/efawateercome/efbillersform/' + id]);
  }

  selectStatusChange() {
    this.getSubCategory();
  }

  selectCatChange(value: any) {
    this.selectedCategory = value.id;
    this.storage.store("categorySearch", value);
    this.getSubCategory();
  }

}
